import { postSendEmailVendors } from 'api/vendors/vendors';
import { ERRORS_TYPES_DOCS } from 'utils/pointOfSale/typesConfig';

export const axiliaryFunctionsVendors = () => {
    const handlerSubmitSendEmailVendors = async (
        drugManufacturerId,
        posId,
        setIsRequiredVendor,
        setIsLoading,
        setOpenModalMissingDocs = (boolean) => {},
    ) => {
        try {
            
                setIsLoading(true);
                const response: any = await postSendEmailVendors(drugManufacturerId, posId);
                if (
                    response &&
                    response?.response?.error?.code === 400 &&
                    [ERRORS_TYPES_DOCS.MISSING_DOCS, ERRORS_TYPES_DOCS.REJECTED_DOCS].includes(
                        response?.response?.data?.validation?.point_of_sale_id[0],
                    )
                ) {
                    setOpenModalMissingDocs(true);
                    setIsLoading(false);
                } else {
                    setIsLoading(true);
                    const response: any = await postSendEmailVendors(drugManufacturerId, posId);
                    if (response?.status === 200) {
                        localStorage.setItem('isRequiredVendor', 'true');
                        setIsLoading(false);
                        setIsRequiredVendor(true);
                    }
                }
                return response;
            
        } catch (ex) {
            setIsLoading(false);
            setIsRequiredVendor(false);
            console.error(ex.message);
        }
    };

    return {
        handlerSubmitSendEmailVendors,
    };
};
